import * as React from 'react'
import { Route }  from 'react-router'

import Drawer from '@material-ui/core/Drawer'
import Hidden from '@material-ui/core/Hidden'

import { withStyles }    from '@material-ui/core/styles'
import { AppBarSpacing } from '../components/atoms/index'
import { Routing }       from '../types'
import SidebarMenu       from './SidebarMenu'

const initState = {
  drawerDocked: true,
}

class Sidebar extends React.Component<{ routing: Routing, classes: any }, typeof initState> {
  public state = initState

  public render () {
    const { classes, routing } = this.props

    const { drawerDocked } = this.state

    const drawerClass =
      drawerDocked
        ? classes.drawerPaperOpen
        : classes.drawerPaperClosed

    return (
      <Hidden smDown>
        <Drawer
          classes={{ paper: drawerClass }}
          variant={'permanent'}
        >
          <AppBarSpacing />
          {
            routing.map(({ icon, name, path, subrouting }) => (
              <Route
                key={path}
                path={path}
                render={({ ...props }) => (
                  <SidebarMenu
                    {...props}
                    onParentClick={this.handleParentClick}
                    onRouteSelect={this.handleRouteSelect}
                    parent={{ name, icon }}
                    subrouting={subrouting}
                  />
                )}
              />
            ))}
        </Drawer>
      </Hidden>
    )
  }

  private handleParentClick = () => {
    this.setState(state => ({ drawerDocked: !state.drawerDocked }))
  }

  private handleRouteSelect = () => {
    this.setState({ drawerDocked: true })
  }
}

const commonDrawerStyles: any = {
  position:   'relative',
  transition: '0.2s',
}

export default withStyles(theme => ({
  drawerPaperOpen:   {
    width: 240,
    ...commonDrawerStyles,
  },
  drawerPaperClosed: {
    width:                          56,
    [ theme.breakpoints.up('sm') ]: {
      width: 72,
    },
    ...commonDrawerStyles,
  },
}))(Sidebar)



// WEBPACK FOOTER //
// ./src/routing/Sidebar.tsx